import { ApisauceConfig } from 'apisauce';
import { GeocodingResponse } from '~client/model/google-maps/geocoding-response';
import { SimpleClient } from '~client/simple-client';

/*
 *
 */
export class GoogleMapsClient extends SimpleClient {
  private readonly apiKey: string;

  constructor(apiKey: string, config?: ApisauceConfig) {
    super(config);
    this.apiKey = apiKey;
  }

  /**
   * Performs a reverse geocode
   * @param latitude
   * @param longitude
   */
  public performReverseGeocode(latitude: number, longitude: number): Promise<GeocodingResponse> {
    return this.get(`/maps/api/geocode/json`, {
      latlng: `${latitude},${longitude}`,
      key: this.apiKey,
    });
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src332225586/src/modules/client/src/client/google-maps-client.ts